import {Box, Typography, Grid} from '@mui/material';
import {ErrorOutline} from '@mui/icons-material';
import React from 'react';
import {omit, pickBy, isEmpty, map, sum, uniq} from 'lodash';
import {useReviewContext} from '../../contexts/ReviewContext';
import {getGroupHeader} from '../../pages/HandoverSummaryPage/handoverValidationHelpers';

export const HandoverValidationMessage: React.FC = () => {
  const context = useReviewContext();
  const isReviewValid = context.allValid;

  if (context.fullValidationLoading || isReviewValid || !context.reviewEditable) {
    return null;
  }

  const validation = context.reviewValidation?.validation ?? {};
  const validationWithoutTypename = omit(validation, '__typename');
  const nonEmptyValidation = pickBy(
    validationWithoutTypename,
    (errors) => !isEmpty(errors)
  );
  const errorGroups = map(nonEmptyValidation, (errors, key) => ({
    key,
    errors: uniq(errors as string[]),
  }));

  const totalErrors = sum(map(errorGroups, (group) => group.errors.length));
  const shouldUseTwoColumns = totalErrors > 5;

  const renderErrorGroup = (group: {key: string; errors: string[]}) => (
    <Box key={group.key} mb={2}>
      <Typography variant="subtitle2" color="error" sx={{fontWeight: 'bold', mb: 1}}>
        {getGroupHeader(group.key)}
      </Typography>
      <ul style={{margin: 0, paddingLeft: '20px'}}>
        {group.errors.map((validationMessage, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${group.key}-${index}`}>
            <Typography sx={{marginRight: 2}} color="error">
              {validationMessage}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  );

  const midpoint = Math.ceil(errorGroups.length / 2);
  const firstColumn = shouldUseTwoColumns ? errorGroups.slice(0, midpoint) : errorGroups;
  const secondColumn = shouldUseTwoColumns ? errorGroups.slice(midpoint) : [];

  return (
    <Box pb={2} pt={2}>
      <Box display="flex" alignItems="center" mb={2}>
        <ErrorOutline color="error" />
        <Typography sx={{marginRight: 2, ml: 2}} color="error">
          <strong>
            Some sections incomplete or failed: <br />
          </strong>
        </Typography>
      </Box>
      {shouldUseTwoColumns ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            {firstColumn.map(renderErrorGroup)}
          </Grid>
          <Grid item xs={6}>
            {secondColumn.map(renderErrorGroup)}
          </Grid>
        </Grid>
      ) : (
        <Box>{firstColumn.map(renderErrorGroup)}</Box>
      )}
    </Box>
  );
};
